import { useInView } from '@/hooks/useInView';
import { verificationSteps } from '@/mocks/homeData';

export default function VerificationProcessSection() {
  const { ref, inView } = useInView({ threshold: 0.1 });

  return (
    <section className="py-12 md:py-16 bg-background-100" id="verification" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950">스카연 검증 절차</h2>
          <a href="/search" className="text-xs text-primary-500 hover:text-primary-600 flex items-center gap-1">
            더보기
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-stretch gap-4">
          {verificationSteps.map((item, idx) => (
            <div
              key={item.step}
              className="flex flex-col md:flex-row items-center gap-2"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 0.5s ease-out ${idx * 0.15}s`,
              }}
            >
              <div className="w-full md:flex-1 bg-white rounded-lg border border-background-200 p-4 text-center hover:border-primary-300 transition-colors group cursor-default">
                <div className="w-10 h-10 mx-auto rounded-full bg-primary-500 text-white text-sm font-bold flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-300">
                  {item.step}
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed whitespace-pre-line">{item.desc}</p>
              </div>
              {idx < verificationSteps.length - 1 && (
                <div className="hidden md:flex items-center justify-center w-6 flex-shrink-0">
                  <i className="ri-arrow-right-line text-foreground-400" />
                </div>
              )}
              {idx < verificationSteps.length - 1 && (
                <div className="md:hidden flex items-center justify-center w-full py-1">
                  <i className="ri-arrow-down-line text-foreground-400" />
                </div>
              )}
            </div>
          ))}
        </div>

        <p className="text-xs text-foreground-500 text-center mt-6">
          스카연은 공정한 검증 절차를 통해 사용자에게 신뢰할 수 있는 정보를 제공합니다.
        </p>
      </div>
    </section>
  );
}